/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_ARTISTS = createAsyncAction('GET_ARTISTS')
export const getArtists = page =>
  apiCall({
    method: 'get',
    endpoint: `/admin/artists/${page}`,
    types: GET_ARTISTS,
  })

export const GET_CURATORS = createAsyncAction('GET_CURATORS')
export const getCurators = (
  page,
  sortingField = 'last_activity',
  sortingOrders = ''
) =>
  apiCall({
    method: 'get',
    endpoint:
      sortingOrders !== 'ASC'
        ? `/admin/curators/${page}/?sortBy=${sortingField}&sorting_orders=${sortingOrders}`
        : `/admin/curators/${page}/?sorting_fields=verified&sorting_orders=ASC&sorting_fields=created_at&sorting_orders=DESC&sorting_fields=in_blacklist&sorting_orders=ASC`,
    types: GET_CURATORS,
  })

export const GET_AUTOPAY_CURATORS = createAsyncAction('GET_AUTOPAY_CURATORS')
export const getAutopayCurators = page =>
  apiCall({
    method: 'get',
    endpoint: `/admin/curators/${page}?autopay=${true}`,
    types: GET_AUTOPAY_CURATORS,
  })

export const SEARCH_USERS = createAsyncAction('SEARCH_USERS')
// eslint-disable-next-line camelcase
export const searchUsers = (search_string, callback) =>
  apiCall({
    method: 'post',
    endpoint: '/admin/users/search',
    query: {
      search_string,
    },
    types: SEARCH_USERS,
    callback,
  })

export const DELETE_CURATOR_ACCOUNT = createAsyncAction(
  'DELETE_CURATOR_ACCOUNT'
)
export const deleteCuratorAccount = callback =>
  apiCall({
    method: 'delete',
    endpoint: '/curator',
    types: DELETE_CURATOR_ACCOUNT,
    callback,
  })

export const DELETE_ARTIST_ACCOUNT = createAsyncAction('DELETE_ARTIST_ACCOUNT')
export const deleteArtistAccount = callback =>
  apiCall({
    method: 'delete',
    endpoint: '/artist',
    types: DELETE_ARTIST_ACCOUNT,
    callback,
  })

export const SEND_QUICK_LOGIN_LINK = createAsyncAction('SEND_QUICK_LOGIN_LINK')
export const sendQuickLoginLink = (email, callback) =>
  apiCall({
    method: 'get',
    endpoint: `/user/quick/${email}`,
    types: SEND_QUICK_LOGIN_LINK,
    callback,
  })

export const BLOCK_CURATOR = createAsyncAction('BLOCK_CURATOR')
// eslint-disable-next-line camelcase
export const blockCurator = curator_id =>
  apiCall({
    method: 'post',
    endpoint: '/admin/block-curator',
    query: {
      curator_id,
    },
    types: BLOCK_CURATOR,
  })

export const CHANGE_CURATOR_AUTOPAY = createAsyncAction(
  'CHANGE_CURATOR_AUTOPAY'
)
export const changeCuratorAutopay = (curator_id, autopay, callback) =>
  apiCall({
    method: 'patch',
    endpoint: `/admin/curator-autopay`,
    query: {
      curator_id,
      autopay,
    },
    types: CHANGE_CURATOR_AUTOPAY,
    callback,
  })

export const GET_SELECTED_CURATOR = createAsyncAction('GET_SELECTED_CURATOR')
export const getSelectedCurator = id =>
  apiCall({
    method: 'get',
    endpoint: `/admin/curator/${id}`,
    types: GET_SELECTED_CURATOR,
  })

export const CHANGE_CURATOR_VALIDATION = createAsyncAction(
  'CHANGE_CURATOR_VALIDATION'
)
export const changeCuratorValidation = curator_id =>
  apiCall({
    method: 'patch',
    endpoint: `/admin/curators/verify`,
    query: {
      curatorId: curator_id,
    },
    types: CHANGE_CURATOR_VALIDATION,
  })

export const SEND_RELEASE_NOTES_READ = createAsyncAction(
  'SEND_RELEASE_NOTES_READ'
)
export const sendReleaseNotesRead = () =>
  apiCall({
    method: 'patch',
    endpoint: `user/release-notes`,
    types: SEND_RELEASE_NOTES_READ,
  })
